

























import CustomAtTextarea from '@/components/CustomAtTextarea.vue';
import SmileyAdd from '@/components/admin/SmileyAdd.vue';
import vue, {PropType} from 'vue';
import RichTextEditor from '@/components/admin/RichTextEditor.vue';

export default vue.extend({
  name: 'AdvertCreationUpdateContent',

  components: {
    RichTextEditor,
    SmileyAdd,
    CustomAtTextarea,
  },

  props: {
    errors: {
      type: Object as PropType<{ title: string[], content: string[] }>,
      required: true,
    },
    content: {
      type: String as PropType<string>,
      required: true,
    },
    title: {
      type: String as PropType<string>,
      required: true,
    },
  },
});
